import {
  Notifications,
  NotificationsDetails,
  NotificationsSettingPage,
  PartnerLevel,
  productNotificationRecipients,
  ProductNotificationsTypeMethods,
  recipients,
  RecipientType,
} from './reducer'
import {
  startLoading,
  stopLoading,
} from '../../../common/modules/loading/actions'
import { LoadingTypes } from '../../../common/modules/loading/reducer'
import { AnyAction, Dispatch } from 'redux'
import { camelize, snakeize } from 'casing'
import {
  fetchNotificationSettingsPageData,
  fetchNotificationSettingsPageDatafromv2,
  fetchReciepients,
  putNotificationsData,
  putNotificationsDataFromV2,
  putUpdateRecipients,
  slackConnection,
  slackDisconecction,
} from '../../../common/api/notifcationAPI'
import { updateAppAlert } from '../../../common/modules/appAlert/actions'
import {
  CoSellNotificationSavedFailureMessage,
  NotificationSavedSuccessMessage,
  NotificationSavedSuccessMessageV2,
  RequestFailureMessage,
} from '../../../common/utils/messagesContants'
import { setNotificationSidePanelLoading } from './notificationSidePanel/actions'
import { RootState } from '../../../store'
import { isEmpty } from 'common/utils/vanilla'
import { AxiosError, AxiosResponse } from 'axios'
import { errorLogger } from '../../../common/utils/errorLogger'
import { getThirdPartyAppList } from '../../../common/modules/thirdPartyAppIntegration/action'
import { Product } from '../../../common/modules/partner/action'
import { actionTypeWrapper } from '../../../common/utils/actionTypeWrapper'
import { clearSlackChannels } from '../../../common/modules/slackChannels/action'
import { getErrorMessages } from '../../../common/utils/error'
import { Recipient } from './notificationSidePanel/reducer'
export enum NotificationsActions {
  SET_NOTIFICATIONS_SETTING_PAGE_DATA = 'SET_NOTIFICATIONS_SETTING_PAGE_DATA',
  SET_INITIAL_NOTIFICATIONS_SETTING_DATA = 'SET_INITIAL_NOTIFICATIONS_SETTING_DATA',
  SET_NOTIFICATIONS = 'SET_NOTIFICATIONS',
  SET_PRODUCT_NOTIFICATIONS_TYPE_METHODS = 'SET_PRODUCT_NOTIFICATIONS_TYPE_METHODS',
  DELETE_USER = 'DELETE_USER',
  ADD_UNREGISTERED_USER = 'ADD_UNREGISTERED_USER',
  ADD_REGISTERED_USER = 'ADD_REGISTERED_USER',
  REMOVE_REGISTERED_USER = 'REMOVE_REGISTERED_USER',
  CLEAR_NOTIFICATIONS_DATA = 'CLEAR_NOTIFICATIONS_DATA',
  UPDATE_CHECKBOX = 'UPDATE_CHECKBOX',
  DISCONNECT_SLACK = 'DISCONNECT_SLACK',
  CONNECT_SLACK = 'CONNECT_SLACK',
  FORM_DIRTY = 'FORM_DIRTY',
  SET_SLACK_RECIPIENTS = 'SET_SLACK_RECIPIENTS',
  UPDATE_PRODUCT_NOTIFICATION_VALUES = 'UPDATE_PRODUCT_NOTIFICATION_VALUES',
  DISCARD_SETTINGS_PAGE_DATA = 'DISCARD_SETTINGS_PAGE_DATA',
}

export const getRecipients =
  (
    partnerId: string,
    productNotificationTypeId: string,
    notificationMethodId: string,
    product: Product
  ) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    await dispatch(setNotificationSidePanelLoading(true))
    try {
      const { data } = await fetchReciepients(
        partnerId,
        product,
        productNotificationTypeId
      )
      const { recipients } = data
      await dispatch(
        actionTypeWrapper(
          product,
          setProductNotificationsTypeMethods({
            partnerId,
            productNotificationTypeId,
            notificationMethodId,
            recipients: camelize(recipients) as unknown as recipients[],
          })
        )
      )
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(setNotificationSidePanelLoading(false))
    }
  }
export const deleteUser = (index: number) => ({
  type: NotificationsActions.DELETE_USER,
  payload: index,
})
export const addUnregisteredUser = (inputValue: string) =>
  ({
    type: NotificationsActions.ADD_UNREGISTERED_USER,
    payload: inputValue,
  }) as unknown as AnyAction
export const setNotifications = (payload: Notifications) => ({
  type: NotificationsActions.SET_NOTIFICATIONS as NotificationsActions.SET_NOTIFICATIONS,
  payload,
})

export const addRegisteredUser = (idpUserId: string) => ({
  type: NotificationsActions.ADD_REGISTERED_USER,
  payload: idpUserId,
})

export const setFormDirty = (val: boolean) => ({
  type: NotificationsActions.FORM_DIRTY,
  payload: val,
})
export const removeRegisteredUser = (idpUserId: string) => ({
  type: NotificationsActions.REMOVE_REGISTERED_USER,
  payload: idpUserId,
})

export const disconnectSlack = (disconnectedData: {
  [x: string]: PartnerLevel
}) => ({
  type: NotificationsActions.DISCONNECT_SLACK,
  payload: disconnectedData,
})

export const setProductNotificationsTypeMethods = (
  payload: ProductNotificationsTypeMethods
) => ({
  type: NotificationsActions.SET_PRODUCT_NOTIFICATIONS_TYPE_METHODS as NotificationsActions.SET_PRODUCT_NOTIFICATIONS_TYPE_METHODS,
  payload,
})

const getExternalIntegrations = (
  partnerLevelData: { [x: string]: PartnerLevel },
  slackActiveId: string
) => {
  let externalIntegrations = {}

  for (const [key, value] of Object.entries(partnerLevelData)) {
    if (value?.isConfigured) {
      if (key === 'SLACK') {
        externalIntegrations = {
          ...externalIntegrations,
          SLACK: snakeize({
            activeChannel: slackActiveId,
          }),
        }
      }
    }
  }
  return externalIntegrations
}

export const saveNotifications =
  (partnerId: string, product: Product, idpUserId?: string) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    const notificationList = getNotificationList(
      getState().notifications[product].notificationsSettingData,
      idpUserId
    )
    const slackActiveId = getState()?.slackChannels?.[product]?.activeChannelId
    const partnerLevelData =
      getState()?.notifications?.[product]?.notificationsSettingData
        ?.availableMethods?.partnerLevel
    const externalIntegrations = getExternalIntegrations(
      partnerLevelData,
      slackActiveId
    )

    await dispatch(startLoading(LoadingTypes.GENERAL))
    let dataToSend = {}
    if (isEmpty(idpUserId)) {
      dataToSend = {
        external_integrations: externalIntegrations,
        notifications: snakeize(notificationList),
      }
    } else {
      dataToSend = snakeize({
        notifications: notificationList,
        partnerId: partnerId,
        idpUserId,
      })
    }
    try {
      await putNotificationsData(product, dataToSend, partnerId, idpUserId)
      await dispatch(
        updateAppAlert({
          message: NotificationSavedSuccessMessage,
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      await dispatch(stopLoading(LoadingTypes.GENERAL))
    }
  }

export const getNotificationList = (
  data: NotificationsSettingPage,
  idpUserId?: string
) => {
  const notificationList: NotificationsDetails[] = []
  const methodList = Object.keys(
    data.availableMethods[idpUserId ? 'userLevel' : 'partnerLevel']
  )

  for (const settings of data.productNotificationTypes) {
    for (const method of settings.productNotificationTypeMethods) {
      const isEmailPartnerLevelMethodType =
        method.type === 'partner_level' && method.methodId === 'EMAIL'
      if (
        (methodList.includes(method.methodId) ||
          isEmailPartnerLevelMethodType) &&
        method.isEnabled === true
      ) {
        const object = {
          productNotificationTypeId: settings.productNotificationTypeId,
          notificationMethodId: method.methodId,
          ...(isEmailPartnerLevelMethodType && {
            recipients: ['opportunity_owner'],
          }),
        }
        notificationList.push(object)
      }
    }
  }
  return notificationList
}

export const saveNotificationsV2 =
  (partnerId: string, product: Product) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    const initialNotificationsData =
      getState().notifications[product]?.initialNotificationsSettingData
    const notificationData =
      getState().notifications[product]?.notificationsSettingData
    if (!notificationData) return

    const notificationList = getNotificationListV2(notificationData)
    const dataToSend = snakeize(notificationList)

    dispatch(startLoading(LoadingTypes.SAVE_NOTIFICATIONS_DATA))

    try {
      await putNotificationsDataFromV2(product, partnerId, dataToSend)
      dispatch(
        updateAppAlert({
          message: NotificationSavedSuccessMessageV2,
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
      await dispatch(
        actionTypeWrapper(
          product,
          setNotificationsSettingsPage(
            notificationData,
            partnerId
          ) as unknown as AnyAction
        )
      )
      await dispatch(
        actionTypeWrapper(
          product,
          setInitialNotificationsSettingsPage(
            notificationData,
            partnerId
          ) as unknown as AnyAction
        )
      )
    } catch (error: any) {
      await dispatch(
        actionTypeWrapper(
          product,
          setNotificationsSettingsPage(
            initialNotificationsData,
            partnerId
          ) as unknown as AnyAction
        )
      )
      await dispatch(
        actionTypeWrapper(
          product,
          setInitialNotificationsSettingsPage(
            initialNotificationsData,
            partnerId
          ) as unknown as AnyAction
        )
      )
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([CoSellNotificationSavedFailureMessage])(
            errorResponse
          ),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(stopLoading(LoadingTypes.SAVE_NOTIFICATIONS_DATA))
    }
  }

export const getNotificationListV2 = (data: NotificationsSettingPage) => {
  const notificationList: productNotificationRecipients = {
    productNotificationRecipients: [],
  }

  for (const settings of data.productNotificationTypes) {
    const recipients = []

    for (const method of settings.productNotificationTypeMethods) {
      if (!method.recipients) continue

      for (const recipient of method.recipients) {
        recipients.push({
          idpUserId: recipient.idpUserId || null,
          destinationValue: recipient.destinationValue || null,
          notificationMethodId: method.methodId,
          metaData: recipient.metaData?.activeChannel || null,
        })
      }
    }

    notificationList.productNotificationRecipients.push({
      productNotificationTypeId: settings.productNotificationTypeId,
      notificationEnabled: settings.notificationEnabled,
      recipients,
      specialRecipients: settings.specialRecipients || [],
    })
  }

  return notificationList
}

//Get Notifications Settings Page Data
export const getSettingsPageData =
  (partnerId: string, product: Product, idpUserId?: string, use_v2 = false) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.GENERAL))
    let includes = null
    let excludes = null
    let dataToBeUsed
    if (use_v2 && product.toLowerCase() === 'oppsync') {
      includes = 'special_recipients,show_cosell_ui_specific'
      excludes = 'owners'
    }
    try {
      if (use_v2) {
        dataToBeUsed = await fetchNotificationSettingsPageDatafromv2(
          product,
          includes,
          excludes
        )
      } else {
        dataToBeUsed = await fetchNotificationSettingsPageData(
          product,
          idpUserId
        )
      }
      const { data } = dataToBeUsed
      const settingsPage = camelize(data)
      await dispatch(
        actionTypeWrapper(
          product,
          setNotificationsSettingsPage(
            settingsPage,
            partnerId,
            idpUserId
          ) as unknown as AnyAction
        )
      )
      await dispatch(
        actionTypeWrapper(
          product,
          setInitialNotificationsSettingsPage(
            settingsPage,
            partnerId,
            idpUserId
          ) as unknown as AnyAction
        )
      )
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
          sidePanelAlert: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(stopLoading(LoadingTypes.GENERAL))
    }
  }
export const setNotificationsSettingsPage = (
  settingsPage: NotificationsSettingPage,
  partnerId: string,
  idpUserId?: string
) => ({
  type: NotificationsActions.SET_NOTIFICATIONS_SETTING_PAGE_DATA,
  payload: { settingsPage, partnerId, idpUserId },
})

export const setInitialNotificationsSettingsPage = (
  settingsPage: NotificationsSettingPage,
  partnerId: string,
  idpUserId?: string
) => ({
  type: NotificationsActions.SET_INITIAL_NOTIFICATIONS_SETTING_DATA,
  payload: { settingsPage, partnerId, idpUserId },
})

export const addUpdateRecipientsNotifications =
  (dataToSend: ProductNotificationsTypeMethods, productId: string) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setNotificationSidePanelLoading(true))
    try {
      await putUpdateRecipients(snakeize(dataToSend), productId.toUpperCase())
      dispatch(
        updateAppAlert({
          message: NotificationSavedSuccessMessage,
          messageType: 'SUCCESS',
          autoClose: true,
          sidePanelAlert: true,
        })
      )
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
          sidePanelAlert: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(setNotificationSidePanelLoading(false))
    }
  }

export const setSlackConnection =
  (
    partnerId: string,
    code: string,
    notificationMethodId: string,
    idpUserId?: string
  ) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.GENERAL))
    try {
      await slackConnection(code, partnerId, notificationMethodId, 'oppsync')
      await dispatch(
        getSettingsPageData(
          partnerId,
          'oppsync',
          idpUserId
        ) as unknown as AnyAction
      )
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(stopLoading(LoadingTypes.GENERAL))
    }
  }

export const clearNotificationsData = () => ({
  type: NotificationsActions.CLEAR_NOTIFICATIONS_DATA,
})

export const setSlackConnectionV2 =
  (partnerId: string, code: string, notificationMethodId: string) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.GENERAL))
    try {
      await slackConnection(code, partnerId, notificationMethodId)
      await dispatch(getThirdPartyAppList(partnerId) as unknown as AnyAction)
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(stopLoading(LoadingTypes.GENERAL))
    }
  }

export const disconnectSlackConnection =
  (partnerId: string, notificationMethodId: string, idpUserId?: string) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.GENERAL))
    try {
      await dispatch(
        getSettingsPageData(
          partnerId,
          'oppsync',
          idpUserId
        ) as unknown as AnyAction
      )
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(stopLoading(LoadingTypes.GENERAL))
    }
  }

export const disconnectSlackConnectionV2 =
  (partnerId: string, notificationMethodId: string) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.GENERAL))
    try {
      await slackDisconecction(partnerId, notificationMethodId)
      await dispatch(getThirdPartyAppList(partnerId) as unknown as AnyAction)
      await dispatch(actionTypeWrapper('flyout', clearNotificationsData()))
      await dispatch(actionTypeWrapper('oppsync', clearNotificationsData()))
      await dispatch(actionTypeWrapper('flyout', clearSlackChannels()))
      await dispatch(actionTypeWrapper('oppsync', clearSlackChannels()))
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(stopLoading(LoadingTypes.GENERAL))
    }
  }

export const updateCheckboxChange = (
  value: boolean,
  index: number,
  methodId: string
) => ({
  type: NotificationsActions.UPDATE_CHECKBOX,
  payload: { value, index, methodId },
})

export const updateMultipleSlackRecipients = (
  data: Record<string, recipients[]>
) => ({
  type: NotificationsActions.SET_SLACK_RECIPIENTS,
  payload: data,
})

export const updateProductNotificationValues = (
  ids: string[],
  key: string,
  value: string
) => ({
  type: NotificationsActions.UPDATE_PRODUCT_NOTIFICATION_VALUES,
  payload: { ids, value, key },
})

export const discardSettingsPageData = () => ({
  type: NotificationsActions.DISCARD_SETTINGS_PAGE_DATA,
})
